// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"edc3f6f9","647":"d1f9e90b"}[chunkId] + ".css";
};